<app-sidenav-container class="full-width full-height">
  <app-sidenav
    #sidenavMenu
    class="d-flex flex-column drawer"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(sessionService.isLoggedIn$ | async) && !(isHandset$ | async)"
    [disableClose]="true"
  >
    <app-sidebar-menu
      [company]="company$ | async"
      (changeProfile)="toggleProfile()"
      (showNotifications)="sidenavNotifications.toggle()"
    ></app-sidebar-menu>
  </app-sidenav>
  <app-sidenav-content>
    <app-sidenav-container class="full-height" hasBackdrop="false">
      <app-sidenav
        #sidenavSubmenu
        class="app__submenu"
        [opened]="sidebarService.subMenuHoverOpened"
        (closedStart)="sidebarService.submenuClose()"
      >
        <app-sidebar-submenu></app-sidebar-submenu>
      </app-sidenav>
      <app-sidenav-content>
        <app-sidenav-container
          class="full-height notifications-menu"
          (backdropClick)="sidebarService.setSpecificItem()"
        >
          <app-sidenav
            #sidenavNotifications
            class="notifications-menu__content"
          >
            <app-button
              size="circle-small"
              class="close"
              (click)="closeNotifications()"
            >
              <app-icon>close</app-icon>
            </app-button>
            <app-notifications-list
              (close)="closeNotifications()"
            ></app-notifications-list>
          </app-sidenav>
          <app-sidenav-content>
            <div class="d-flex flex-column app__base">
              <app-notification-popup
                [visibility]="notificationPopup"
                (openNotifications)="sidenavNotifications.toggle()"
              ></app-notification-popup>
              <div class="router-container">
                <router-outlet (activate)="onActivate()"></router-outlet>
              </div>
            </div>
          </app-sidenav-content>
        </app-sidenav-container>
      </app-sidenav-content>
    </app-sidenav-container>
    <div class="w-100 h-100 loading" *ngIf="loading">
      <app-progress-bar color="primary" mode="indeterminate"></app-progress-bar>
    </div>
  </app-sidenav-content>
</app-sidenav-container>
<app-snackbar-container></app-snackbar-container>
@if (showCookiesBanner) {
  <app-cookies-banner
    (accepted)="onCookiesAccepted()"
    (closed)="onCookiesClosed()"
  ></app-cookies-banner>
}
